import { on } from '@ember/modifier';

import highlightResult from 'webapp/helpers/highlight-result';
import joinClasses from 'webapp/helpers/join-classes';
import BlockDebugButtonComponent from 'webapp/components/block/debug-button';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormCheckboxComponent from 'webapp/components/form/checkbox';
import GoalsHierarchyTableRowComponent, {
	type Args,
} from 'webapp/components/goals/hierarchy-table-row';
import GoalsInsightsSubgoalCompatibilityComponent from 'webapp/components/goals/insights/subgoal-compatibility';
import GoalsProgressComponent from 'webapp/components/goals/progress';
import GoalsStatusComponent from 'webapp/components/goals/status/index';
import GroupSelectComponent from 'webapp/components/group-select';
import OptionsButtonComponent from 'webapp/components/options-button';
import OwnerSelectComponent from 'webapp/components/owner-select';

export default class GoalsStrategyTableRowComponent extends GoalsHierarchyTableRowComponent<Args> {
	get icon() {
		return this.args.model.isObjectiveType ? 'Flag' : 'Target';
	}
	<template>
		<tr data-id={{@model.id}} class={{joinClasses this.classNames}}>
			<td class="cc no-grow">
				{{#if @batchSelect}}
					<FormCheckboxComponent
						@name="goals-table-row"
						@selected={{this.isSelected}}
						@theme="blue"
						@onChange={{this.selectItem}}
					/>
				{{/if}}
			</td>

			<td class="c0 c1 board">

				<div class="icon-and-title-wrapper">

					<div class="icon-wrapper">

						{{#if @depth}}
							<CommonUiIconComponent @name={{this.iconForArrow}} @size="md" />
						{{/if}}

						<span class="target" role="button" {{on "click" this.viewDetails}}>
							<CommonUiIconComponent @name={{this.icon}} @size="lg" />
							{{#if this.emblemTypeName}}
								<div class="emblem emblem--{{this.emblemTypeName}}"></div>
							{{/if}}
						</span>

						<BlockDebugButtonComponent @blockId={{@model.blockId}} />

					</div>

					<div class="title-wrapper">
						<div class="flex">
							<a role="button" class="goal-title" {{on "click" this.viewDetails}}>
								{{highlightResult text=@model.title match=@model.activeFilter}}
							</a>
							<div class="labelicons">
								{{#if @model.favorite}}
									<span class="labelicon">
										<CommonUiIconComponent @name="StarFill" @size="sm" />
									</span>
								{{/if}}
							</div>
						</div>

						<div class="flex">
							{{#if this.subgoalsCount}}
								<a
									class="toggler toggler--{{if this.isExpanded 'expanded'}}"
									{{on "click" this.toggleExpanded}}
								>
									<CommonUiIconComponent
										@name="ChevronDown"
										@size="xs"
									/>{{this.subgoalsText}}
								</a>
								{{#if @model.group}}
									<span class="dot">&centerdot;</span>
								{{/if}}
							{{/if}}

							{{#if @model.group}}
								<GroupSelectComponent @model={{@model}} @canEdit={{false}} />
							{{/if}}
						</div>
					</div>

				</div>
			</td>

			<td class="c2" data-label="Progress: ">
				<div class="flex">
					<GoalsInsightsSubgoalCompatibilityComponent @model={{@model}} />
					<GoalsProgressComponent
						@model={{@model}}
						@goalData={{this.goalData}}
						@size="small"
					/>
				</div>
			</td>

			<td class="c3 prio-low" data-label="Timeframe: ">
				{{@model.timeframeText}}
			</td>

			<td class="c4 prio-low" data-label="Status: ">
				{{#if this.goalData.status}}
					<GoalsStatusComponent @status={{this.goalData.status}} />
				{{/if}}
			</td>

			<td class="c5 prio-low" data-label="Owner: ">
				<OwnerSelectComponent
					@model={{@model}}
					@canEdit={{@model.canEdit}}
					@isOwnerNameHidden={{true}}
				/>
			</td>

			<td class="c6 button-ct last">
				<OptionsButtonComponent
					@options={{this.options}}
					@onAction={{this.doOptionsAction}}
				/>
			</td>
		</tr>
	</template>
}
